import { v4 as uuidv4 } from 'uuid';


const IndianSnacks = [{
    "name": "Hara Bhara Kabab",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Indian Snacks",
    "id": uuidv4()
  },
  {
    "name": "gobi manchurian",
    "price": [325, 690],
    "isVeg": true,
    "rating": 4.5,
    "type": "Indian Snacks",
    "id": uuidv4()
  },
  {
    "name": "Chakli",
    "price": [125, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Indian Snacks",
    "id": uuidv4()
  }
  ,
  {
    "name": "Rava Dhokla",
    "price": [325, 690],
    "isVeg": true,
    "rating": 4.5,
    "type": "Indian Snacks",
    "id": uuidv4()
  },
  {
    "name": "Veg Spring Roll",
    "price": [325, 690],
    "isVeg": true,
    "rating": 4.5,
    "type": "Indian Snacks",
    "id": uuidv4()
  },
  {
    "name": "Vada Pav",
    "price": [100, 190],
    "isVeg": true,
    "rating": 4.5,
    "type": "Indian Snacks",
    "id": uuidv4()
  },
  {
    "name": "Medu Vada",
    "price": [130, 210],
    "isVeg": true,
    "rating": 4.5,
    "type": "Indian Snacks",
    "id": uuidv4()
  }
]

export default IndianSnacks;